import { Box } from '@mui/material';
import { FC } from 'react';

interface HeaderBarLogoProps {
    alt: string;
    opticalOffsetX?: number;
    src: string;
    width: number;
}

const HeaderBarLogo: FC<HeaderBarLogoProps> = ({ alt, opticalOffsetX = 0, src, width }) => (
    <Box sx={{ display: 'flex', justifyContent: 'center', mb: '10px' }}>
        <Box
            alt={alt}
            component="img"
            src={src}
            sx={{
                display: 'block',
                height: 'auto',
                transform: opticalOffsetX ? `translateX(${opticalOffsetX}px)` : 'none',
                width,
            }}
        />
    </Box>
);

export default HeaderBarLogo;
